import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_contact_ext_RowClass} from '../../../dbschema/bl_crm_contact_ext.model';
import {bl_crm_contact_hdr_RowClass} from '../../../dbschema/bl_crm_contact_hdr.model';
import {bl_crm_contact_line_RowClass} from '../../../dbschema/bl_crm_contact_line.model';

export class ContactContainerModel extends BaseContainerModel {
  bl_crm_contact_hdr: bl_crm_contact_hdr_RowClass = new bl_crm_contact_hdr_RowClass();
  bl_crm_contact_exts: bl_crm_contact_ext_RowClass[] = [];
  bl_crm_contact_lines: bl_crm_contact_line_RowClass[] = [];
}
